import { forwardRef, useCallback, useMemo } from "react";
import { MultiValue, Options, SingleValue } from "react-select";
import {
  CategorySelectTree,
  SelectOptionTree,
} from "src/components/CategorySelectTree";
import { findElementByHid } from "src/components/CategorySelectTree/utils";

import { isMultiValue } from "../../utils";

export interface CategorySelectTreeAdapterProps {
  value?: number | number[];
  onChange: (value: number | number[]) => void;
  options: Options<SelectOptionTree>; // Убрали опциональность
  isMulti?: boolean;
  placeholder?: string;
  isLoading?: boolean;
  isClearable?: boolean;
}

/**
 * Адаптер для компонента CategorySelectTree с поддержкой forwardRef
 */
export const ForwardedCategorySelectTreeAdapter = forwardRef<
  HTMLDivElement,
  CategorySelectTreeAdapterProps
>((props, ref) => {
  const selected = useMemo(
    () =>
      props.value ? findElementByHid(props.value, props.options) : undefined,
    [props.value, props.options],
  );

  const onChange = useCallback(
    (value?: MultiValue<SelectOptionTree> | SingleValue<SelectOptionTree>) => {
      if (isMultiValue(value)) {
        const values = value.map((item) => item.value);
        return props.onChange(values);
      } else if (value && !Array.isArray(value)) {
        props.onChange(value.value);
      }
    },
    [props],
  );

  return (
    <div ref={ref}>
      <CategorySelectTree
        {...props}
        value={selected}
        onChange={onChange}
        isClearable
      />
    </div>
  );
});

// Добавляем displayName для лучшей отладки
ForwardedCategorySelectTreeAdapter.displayName =
  "ForwardedCategorySelectTreeAdapter";
